import { useSelector, useDispatch } from "react-redux";
import {
  createVendorItem,
  getAllVendorItems,
  getDataForEdit,
  updateVendorItem,
  deleteVendorItem,
} from "../../store/Vendor/VendorApi";
import { vendorSliceAction } from "../../store/Vendor/VendorSlice";
import { headTitle } from "../../utility/GetTableListName";

import MainComponent from "../../components/Base/MainComponent";
//importing constant form option to create form input
import { FormOptionsVendor } from "../../ConstantData/FormOptions";
//importing inital form data to store value state
import { InitialVendorFormData } from "../../ConstantData/InitialData";

//imporint form data error
import { ErrorVendorFormData } from "../../ConstantData/ErrorOption";
import { useEffect } from "react";
function Vendor() {
  const dispatch = useDispatch();
  useEffect(() => {
    // dispatch(getAllVendorItems());
  }, []);
  const isSuccess = useSelector((state) => state.applevel.isSuccess);
  const vendorList = useSelector((state) => state.vendor.vendorList);
  const InitialFormDataStore = useSelector((state) => state.vendor.initialData);
  const vendorEditData = useSelector((state) => state.vendor.dataEdit);
  let vendorFormError = useSelector((state) => state.vendor.errorData);
  let isError = useSelector((state) => state.vendor.isError);
  vendorFormError = { ...ErrorVendorFormData, ...vendorFormError };
  const headTitleLabel = headTitle(FormOptionsVendor, [
    "Name",
    "Type",
    "Contact Number",
  ]); //array is filed that is included in list heading

  return (
    <MainComponent
      InitialFormData={InitialVendorFormData}
      //function coming from store
      createFun={createVendorItem} //create function coming from store
      updateFun={updateVendorItem} //update function coming from store
      getDataForEdit={getDataForEdit}
      delteFun={deleteVendorItem}
      FormOptions={FormOptionsVendor}
      OptionName="Create Vendor"
      OptionNameList="Vendor"
      generalList={vendorList}
      headTitle={headTitleLabel}
      EditData={vendorEditData}
      ErrorData={vendorFormError}
      isError={isError}
      InitialFormDataStore={InitialFormDataStore}
      setErrorData={vendorSliceAction.setErrorData}
      isNotDeleteBtn={false}
      isSuccess={isSuccess}
    />
  );
}

export default Vendor;
